import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NetworkDiagramStateService {

  constructor() {
  }

  setLocationsState(diagramId, locationsState): void {
    sessionStorage.setItem(`network-diagram.${diagramId}.elementsLocations`, JSON.stringify(locationsState));
  }

  getLocationsState(diagramId): any {
    const locations = sessionStorage.getItem(`network-diagram.${diagramId}.elementsLocations`);
    return locations ? JSON.parse(locations) : {};
  }

  setClustersState(diagramId, clustersState): any {
    sessionStorage.setItem(`network-diagram.${diagramId}.clusters`,
      JSON.stringify({clusters: clustersState.clusters, changed: clustersState.changed}));
  }

  getClustersState(diagramId): any {
    const value = sessionStorage.getItem(`network-diagram.${diagramId}.clusters`);
    return value ? JSON.parse(value) : {clusters: [], changed: false};
  }

  getViewPosition(diagramId): any {
    const position = sessionStorage.getItem(`network-diagram.${diagramId}.viewPosition`);
    return position ? JSON.parse(position) : position;
  }

  setViewPosition(diagramId, viewPosition): any {
    sessionStorage.setItem(`network-diagram.${diagramId}.viewPosition`, JSON.stringify(viewPosition));
  }

  getDiagramZoom(diagramId): any {
    const zoom = sessionStorage.getItem(`network-diagram.${diagramId}.zoom`);
    return zoom ? JSON.parse(zoom) : zoom;
  }

  setDiagramZoom(diagramId, zoom): any {
    sessionStorage.setItem(`network-diagram.${diagramId}.zoom`, JSON.stringify(zoom));
  }
}
